export default __webpack_public_path__ + "static/media/unknown.166bfe29.svg";